import { createSlice } from "@reduxjs/toolkit";
import { cacheService } from "../../Core/Api/services";
import { DbMessengerGroupInfos } from "../../Core/Api/Types/db-messenger-group-infos";
import { RootState } from "../redux-store";

export interface ReduxStateGroupMessages {
  groupMessages: DbMessengerGroupInfos[];
  newMessages: number;
  groupMessageSelected: DbMessengerGroupInfos | null;
}

const initialState: ReduxStateGroupMessages = {
  groupMessages: [],
  newMessages: 0,
  groupMessageSelected: null,
};

export const groupMessagesSlice = createSlice({
  name: "groupMessages",
  initialState,
  reducers: {
    SetGroupMessages: (state, action) => {
      state.groupMessages = action.payload;
      console.debug("messenger:SetGroupMessages() ok");
    },
    AddGroupMessage: (state, action) => {
      state.groupMessages = [...state.groupMessages, action.payload];
      console.debug("messenger:AddGroupMessages() ok");
    },
    UpdateGroupMessage: (state, action) => {
      state.groupMessages = state.groupMessages.map((group) =>
        group.id === action.payload.id ? action.payload : group
      );
      console.debug("messenger:UpdateGroupMessages() ok");
    },
    DeleteGroupMessage: (state, action) => {
      state.groupMessages = state.groupMessages.filter((group) => group.id !== action.payload);
      if (state.groupMessageSelected?.id === action.payload)
        state.groupMessageSelected = state.groupMessages.length > 1 ? state.groupMessages[0] : null;
      console.debug("messenger:DeleteGroupMessages() ok");
    },
    NewMessage: (state, action) => {
      // Add in potential selected group message on Messenger/Conversation page
      if (state.groupMessageSelected && state.groupMessageSelected?.id === action.payload.groupId)
        state.groupMessageSelected?.messages
          ? state.groupMessageSelected!.messages.push(action.payload)
          : (state.groupMessageSelected!.messages = [action.payload]);

      // Add to group stored in this state (considering we already loaded the groups by API)
      if (state.groupMessages && state.groupMessages.length > 0) {
        if (state.groupMessages.find((x) => x.id === action.payload.groupId) !== undefined)
          state.groupMessages.find((x) => x.id === action.payload.groupId)!.messages?.push(action.payload);
      }

      // Increment counter
      if (action.payload.userId !== cacheService.GetUserInfo()?.id) ++state.newMessages;

      console.debug("messenger:NewMessage() ok");
    },
    SetMessageBadgeNumber: (state, action) => {
      state.newMessages = action.payload;
    },
    DecrementMessageBadge: (state) => {
      if (state.newMessages !== 0) --state.newMessages;
      console.debug("messenger:DecrementMessageBadge() ok");
    },
    DeleteMessage: (state, action) => {
      if (state.groupMessageSelected && state.groupMessageSelected?.id === action.payload.groupId)
        state.groupMessageSelected.messages!.find((message) => message.id === action.payload.id)!.deleted = true;
      console.debug("messenger:DeleteMessage() ok");
    },
    SetGroupMessageSelected: (state, action) => {
      state.groupMessageSelected = action.payload;
    },
  },
});

export const {
  SetGroupMessages,
  AddGroupMessage,
  UpdateGroupMessage,
  DeleteGroupMessage,
  NewMessage,
  DecrementMessageBadge,
  DeleteMessage,
  SetGroupMessageSelected,
  SetMessageBadgeNumber,
} = groupMessagesSlice.actions;

export const GetGroupMessages = (state: RootState): DbMessengerGroupInfos[] =>
  state.groupMessagesSlice.groupMessages || [];

export const GetGroupMessageSelected = (state: RootState): DbMessengerGroupInfos | null =>
  state.groupMessagesSlice.groupMessageSelected || null;

export const GetUnreadMessages = (state: RootState): number => state.groupMessagesSlice.newMessages || 0;

export default groupMessagesSlice.reducer;
